import {Injectable} from '@angular/core';
import {
    HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {TokenService} from '../services/token.service';
import {Router} from '@angular/router';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthInterceptor implements HttpInterceptor {

    constructor(
        private token: TokenService,
        private router: Router
    ) {
    }

    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        const showLogin = req.headers.get('show_login');
        const currentURL = this.router.url;
        if (this.token.hasAccessToken()) {
            req = req.clone({
                setHeaders: {
                    'Authorization': 'Bearer ' + this.token.getAccessToken(),
                }
            });
        }
        return next.handle(req).pipe(tap(event => {}, err => {
            if (err instanceof HttpErrorResponse && err.status == 401) {
                if (!showLogin || showLogin === 'false' || req.url.indexOf('/oauth/token') > -1 || currentURL.indexOf('/login') > -1) {
                    return;
                }
                this.router.navigate(['/login'], { queryParams: { returnUrl: currentURL }});
            }
        }));
    }
}
